// src/features/people/PeopleModule.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PeopleList from './PeopleList';
import PersonForm from './PersonForm';
import PersonProfile from './PersonProfile';

function PeopleModule() {
  return (
    <Routes>
      {/* Ruta base: muestra la lista de personas */}
      <Route index element={<PeopleList />} />
      
      {/* Ruta para crear nueva persona */}
      <Route path="add" element={<PersonForm />} />
      
      {/* Ruta para editar una persona existente */}
      <Route path=":id/edit" element={<PersonForm />} />
      
      {/* Ruta para ver perfil de persona */}
      <Route path=":id" element={<PersonProfile />} />
    </Routes>
  );
}

export default PeopleModule;